import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    take : 25,
    columns: [
        {
            key : "kooi_id",
            label : "Kooi #",
            display : true
        },
        {
            key : "sub_type",
            label : "Related to",
            display : true
        },
        {
            key : "data.text",
            label : "Message",
            display : true
        },
        {
            key : "upcoming_at",
            label: "Upcoming At",
            display : true
        },
    ],
    loaded : false,
    loadingMore: false,
    allLoaded : false,
    addNew : false,
})

  // getters
  const getters = {
  }

  // actions
  const actions = {
    async loadEvents({commit, state, rootState}){
        if(state.allLoaded == false){
            commit("loaded", false);
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/dashboard/events", {params : {skipe: state.list.length, take:state.take}}).then((response) => {
                commit("setEvents", response.data.data);
                commit("loaded", true);
            })
        }
    },
  }

  // mutations
  const mutations = {
      init(state, data){
        state.list = data;
        state.loaded = true;
      },
      setEvents(state, list){
          if(list == undefined || list.length <= 0 || list.length <= state.take){
            state.allLoaded = true;
          }
          state.list.push(...list);
      },
      increasePage(state){
          state.loadingMore = true;
          state.page++;
      },
      loaded(state, status){
          state.loadingMore = status;
          state.loading = status;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
